import { useEffect } from 'react';

const SEO = ({ title, description, keywords, ogTitle, ogDescription, ogImage, ogUrl, canonical }) => {
    useEffect(() => {
        // Update Title
        if (title) {
            document.title = `${title} | Go Nova Media`;
        }

        // Update Description
        let metaDescription = document.querySelector('meta[name="description"]');
        if (metaDescription) {
            metaDescription.setAttribute('content', description || 'Go Nova Media is a global MCN and Creative Service Provider optimizing revenue for TV series, movies, and creators.');
        } else {
            metaDescription = document.createElement('meta');
            metaDescription.name = 'description';
            metaDescription.content = description;
            document.head.appendChild(metaDescription);
        }

        // Canonical Tag
        let linkCanonical = document.querySelector('link[rel="canonical"]');
        if (!linkCanonical) {
            linkCanonical = document.createElement('link');
            linkCanonical.rel = 'canonical';
            document.head.appendChild(linkCanonical);
        }
        linkCanonical.setAttribute('href', canonical || window.location.href);

        // Open Graph Tags
        const ogTags = [
            { property: 'og:title', content: ogTitle || title },
            { property: 'og:description', content: ogDescription || description },
            { property: 'og:image', content: ogImage || 'https://gonova.media/brand/og-image.jpg' }, // Placeholder for real image
            { property: 'og:url', content: ogUrl || window.location.href },
            { property: 'og:type', content: 'website' }
        ];

        ogTags.forEach(tag => {
            let meta = document.querySelector(`meta[property="${tag.property}"]`);
            if (!meta) {
                meta = document.createElement('meta');
                meta.setAttribute('property', tag.property);
                document.head.appendChild(meta);
            }
            meta.setAttribute('content', tag.content);
        });

        // Twitter Card Tags
        const twitterTags = [
            { name: 'twitter:card', content: 'summary_large_image' },
            { name: 'twitter:title', content: ogTitle || title },
            { name: 'twitter:description', content: ogDescription || description },
            { name: 'twitter:image', content: ogImage || 'https://gonova.media/brand/og-image.jpg' }
        ];

        twitterTags.forEach(tag => {
            let meta = document.querySelector(`meta[name="${tag.name}"]`);
            if (!meta) {
                meta = document.createElement('meta');
                meta.name = tag.name;
                document.head.appendChild(meta);
            }
            meta.setAttribute('content', tag.content);
        });

    }, [title, description, ogTitle, ogDescription, ogImage, ogUrl, canonical]);

    return null;
};

export default SEO;
